import { render } from "./InputChoice.vue?vue&type=template&id=76c2b016"
import script from "./InputChoice.vue?vue&type=script&lang=js"
export * from "./InputChoice.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__